import React, { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./partner.module.css"; // Import the CSS Module
import pfizerLogo from "./../../../../ASSETS/LOGO/pfizer.svg";
import gskLogo from "./../../../../ASSETS/LOGO/gsk.svg";
import janssenLogo from "./../../../../ASSETS/LOGO/janssen.svg";
import rocheLogo from "./../../../../ASSETS/LOGO/roche.svg";
import genentechLogo from "./../../../../ASSETS/LOGO/genentech.svg";
import bdLogo from "./../../../../ASSETS/LOGO/bd.svg";
import abbotLogo from "./../../../../ASSETS/LOGO/abbott.png";
import thermofisherLogo from "./../../../../ASSETS/LOGO/thermofisher.svg";

const PartnersCarousel = () => {
  const logos = [
    { src: pfizerLogo, alt: "Pfizer" },
    { src: gskLogo, alt: "GSK" },
    { src: janssenLogo, alt: "Janssen" },
    { src: rocheLogo, alt: "Roche" },
    { src: genentechLogo, alt: "Genentech" },
    { src: bdLogo, alt: "BD" },
    { src: abbotLogo, alt: "Abbott" },
    { src: thermofisherLogo, alt: "Thermo Fisher Scientific" },
    { src: pfizerLogo, alt: "Pfizer" },
    { src: gskLogo, alt: "GSK" },
    { src: janssenLogo, alt: "Janssen" },
    { src: rocheLogo, alt: "Roche" },
    { src: genentechLogo, alt: "Genentech" },
    { src: bdLogo, alt: "BD" },
    { src: abbotLogo, alt: "Abbott" },
    { src: thermofisherLogo, alt: "Thermo Fisher Scientific" },
  ];

  const itemsPerSlide = 7;
  const totalLogos = logos.length;

  const extendedLogos = [
    ...logos.slice(totalLogos - itemsPerSlide),
    ...logos,
    ...logos.slice(0, itemsPerSlide),
  ];

  const [position, setPosition] = useState(0);
  const [moving, setMoving] = useState(false);
  const carouselRef = useRef(null);

  const nextSlide = () => {
    if (!moving) {
      setMoving(true);
      setPosition((prevPosition) => (prevPosition + 1) % extendedLogos.length);
    }
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, [moving]);

  useEffect(() => {
    if (moving) {
      const timeout = setTimeout(() => {
        setMoving(false);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [moving]);

  return (
    <Container fluid className={styles.partnersSection}>
      <div
        className={styles.partnersCarouselContainer}
        style={{ overflow: "hidden" }}
      >
        <div
          ref={carouselRef}
          className={styles.partnersCarousel}
          style={{
            display: "flex",
            transition: "transform 0.5s ease",
            transform: `translateX(-${(position * 100) / itemsPerSlide}%)`,
          }}
        >
          {extendedLogos.map((logo, index) => (
            <div
              className={styles.brandItem}
              key={index}
              // style={{
              //   flex: "0 0 auto",
              //   width: `calc(100% / ${itemsPerSlide})`,
              //   margin: "0 5px",
              //   display: "flex",
              //   justifyContent: "center",
              // }}
            >
              <img
                className="d-block mx-auto"
                src={logo.src}
                alt={logo.alt}
                style={{
                  maxHeight: "100px",
                  objectFit: "contain",
                  width: "100%",
                  transition: "filter 0.3s ease-in-out",
                  margin: "0 5px",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default PartnersCarousel;
